/*
 * Algolia Utility functions
 *
 * This script should be CENTER PLACE of defining
 * all custom logic related to Algolia Search like,
 * excluding 'COLOR BLOCK' and 'COLOR BLANKET',
 * Non-Collaborations in Collaboration value.
 **/

export const DEFAULT_ATTR_TO_RETRIEVE = [
  'title',
  'image',
  'featured_image',
  'named_tags',
  'handle',
  'objectID',
  'sku',
  'product_type',
  'products_count',
  'variants_count',
  'meta.loloi.collaboration',
  'meta.loloi.discontinued',
  'meta.loloi.style',
  'meta.loloi.products_json',
  'meta.loloi.product_count',
  'meta.loloi.eta_date',
  'meta.loloi.lead_time',
  'meta.loloi.variant_size',
  'meta.loloi.compare_at_prices',
  'meta.loloi.map_category',
  'meta.loloi.usa_map',
  'meta.loloi.canada_map',
  'meta.loloi.unrestricted_by_map',
  'options',
  'price',
  'variant_title',
  'inventory_quantity',
  'id',
];

/**
 * excludeFilter
 * Exclude specific product/collection from Search Result
 */
export const EXCLUDE_FILTER = window.LoloiConfig.exclude_filter;

// Non Exclusive Collaborations
export const NON_EXCLUSIVE = window.LoloiConfig.non_exclusive;

// Collaborations to add "× Loloi"
export const XLOLOI_COLLAB = window.LoloiConfig.xloloi_collab;

// Collaborations to only allow 1 item to be purchased for.
export const SINGLE_PURCHASE = window.LoloiConfig.single_purchase;

// Collaborations to hide on product cards
export const HIDE_COLLAB = window.LoloiConfig.hide_collab;

// Collaborations to hide on product cards entered manually via customizer
export const MANUAL_HIDE_COLLAB = window.LoloiConfig.manual_hide_collab;

// Collaborations to exclude from algolia filter, and hide from product downloads
export const NON_FILTER = window.LoloiConfig.non_filter;

// Non Collaborations in Collaboration field
export const NON_COLLAB = window.LoloiConfig.non_collab;

// User Authorised Collaborations
export const USER_AUTH_COLLAB = window.LoloiConfig.user_auth_collab;
// User Unauthorised Collaborations
export const USER_UNAUTH_COLLAB = window.LoloiConfig.user_unauth_collab;



// WEBPACK FOOTER //
// ./src/scripts/src/common/constant.js